import { Navigate, Outlet } from 'react-router';
import { UNPROTECTED_PATHS } from '../navigation/paths';
import useAuth from '@/features/auth/hooks/useAuth';


export default function AuthGuard() {
    const { parent, isLoading } = useAuth();

    if (isLoading) {
        return null; // Or a loading spinner
    }

    if (parent) {
        return <Outlet />;
    } else {
        return <Navigate to={UNPROTECTED_PATHS.login} replace />;
    }
}

